import { Button, ButtonOutlined, ButtonSpinner } from '@components/common/Button/index.js';
import { shadowSoft } from '@components/previewUI/styles/global.js';
import { Box, Flex } from '@styles/flexBox';
import { linkDesignTypes } from '@utils/enums.js';
import styled, { css } from 'styled-components';

export const ModalInnerWrap = styled(Flex)`
  flex-direction: column;
  justify-content: ${(props) => props.justifyContent || 'space-between'};
  // max-height: ${(props) => props.maxHeight || '700px'};
  max-height: ${(props) => props.maxHeight};
  -moz-appearance: none;
  -webkit-appearance: none;
  overflow-y: unset;

  @media (max-width: 767px) {
    max-height: none;
  }

  ${(props) =>
    props.isAnalytics &&
    css`
      padding: 0 3rem;

      @media (max-width: 480px) {
        padding: 0;
        margin-bottom: 80px;
      }
    `}

  ${(props) =>
    props.minHeight &&
    css`
      min-height: ${props.minHeight}px;
    `}

  ${(props) =>
    props.isNotPremium &&
    css`
      pointer-events: none;
      opacity: 0.3;
    `}

  ${(props) =>
    props.blogPost &&
    css`
      justify-content: flex-start;
      height: 100%;
    `}

  ${(props) =>
    props.scrollY &&
    css`
      overflow-y: scroll;
      padding-right: 12px;
    `}

  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const ModalContentBox = styled(Box)`
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: visible;
  padding: 10px 12px 0;
`;

export const ModalSubtitle = styled(Box)`
  font-size: 16px;

  span {
    cursor: pointer;
    color: #4e75fe;
  }

  ${(props) =>
    props.center &&
    css`
      text-align: center;
    `}
`;

export const ModalText = styled(Box)`
  font-size: 16px;
`;

export const ModalEmoji = styled(Box)`
  font-size: 45px;
  text-align: center;
`;

export const ModalDisconnectButtons = styled(Flex)`
  justify-content: space-evenly;

  @media (max-width: 576px) {
    gap: 15px;
  }

  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.5;
      pointer-events: none;
      cursor: not-allowed;
    `}

  ${(props) =>
    props.justifyContent &&
    css`
      justify-content: ${props.justifyContent};
    `}

  ${(props) =>
    props.insideFaq &&
    css`
      margin-top: 32px;

      @media (max-width: 767px) {
        margin-top: 0;
      }
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.insideCollect &&
    css`
      margin-top: 20px;
    `}
`;

export const CancelModalButton = styled(Button)`
  width: 30%;
  background: var(--main-background);
  color: var(--main-black);
`;

export const CancelModalButtonMain = styled(Button)`
  width: 30%;
  background: var(--main-background);
  color: var(--main-black);

  bor

`;

export const SaveModalButton = styled(ButtonSpinner)`
  width: 30%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PublishButton = styled(ButtonSpinner)`
  padding: 0 12px;

  display: flex;
  gap: 5px;
  justify-content: center;
  align-items: center;

  border-radius: 36px;
  background: #5a41f5;
  border-color: #5a41f5;

  &:hover {
    background: #5a41f5;
    border-color: #5a41f5;
  }

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.background &&
    css`
      background: ${props.background};
      border-color: ${props.background};

      &:hover {
        background: ${props.background};
        border-color: ${props.background};
      }
    `}
`;

export const PublishButtonIcon = styled.img`
  width: 21px;
  height: 21px;
`;

export const CancelButton = styled(ButtonOutlined)`
  width: 30%;
  min-height: 32px;
  padding: 0 16px;
  line-height: 32px;
`;

export const SaveButton = styled(Button)`
  width: 30%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ModalSpinnerBox = styled(Flex)`
  margin-left: 10px;

  ${(props) =>
    props.savingBot &&
    css`
      margin-top: 2px;
      margin-left: 8px;
    `}
`;

export const ModalContentWrap = styled(Flex)`
  @media (max-width: 767px) {
    flex-direction: column;
  }

  @media (min-width: 768px) {
    justify-content: space-between;
  }

  @media (max-width: 992px) {
    ${(props) =>
      props.actionModal &&
      css`
        flex-direction: column;
      `}
  }

  ${(props) =>
    props.product &&
    css`
      flex-direction: column;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}
`;

export const ModalImageBox = styled(Box)`
  position: relative;
  width: 345px;
  margin-bottom: 10px;

  @media (max-width: 767px) {
    margin-bottom: 20px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (max-width: 568px) {
    width: 100%;
  }

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}

  ${(props) =>
    props.insideShop &&
    css`
      width: 150px;
      height: 150px;

      @media (max-width: 768px) {
        margin: 0;
      }
    `}

  ${(props) =>
    props.isProductPreview &&
    css`
      width: 100%;
      height: 350px;
    `}
`;

export const ModalImageTextBox = styled(Box)`
  position: relative;
  width: 345px;
  padding: 20px 46px 20px 20px;
  background: #100629;
  border-radius: 6px;
  overflow: hidden;
  word-wrap: break-word;

  @media (max-width: 568px) {
    width: 100%;
  }

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
  ${(props) =>
    props.isLink &&
    css`
      padding: 0 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      word-wrap: break-word;
    `}

  ${(props) =>
    props.isButtonLink &&
    css`
      padding: 17px 20px;
    `}


  ${(props) =>
    props.buttonLinkRightArrow &&
    css`
      padding: 0 46px;
    `}

  ${(props) =>
    props.background &&
    css`
      background: ${props.background};
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.isLinkButtonImagePreview &&
    css`
      padding-left: 70px;
      padding-right: 70px;
    `}

  ${(props) =>
    props.borderBottomRadius &&
    css`
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    `}

  ${(props) =>
    props.buttonShape === 'cover' &&
    props.image &&
    css`
      background: url(${props.image}) no-repeat center / cover;

      &:before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: ${props.background};
        opacity: 0.2;
      }
    `}

  ${(props) =>
    props.buttonShape === 'full' &&
    props.image &&
    css`
      padding-left: 38%;
    `}


  ${(props) =>
    props.paddingTop &&
    props.buttonShape === 'card' &&
    css`
      padding-top: ${props.paddingTop + 12}px;
      padding-bottom: 15px;

      @media (max-width: 797px) {
        padding-top: ${props.paddingTop + 12}px;
      }
    `}

  ${(props) =>
    props.linkHeight &&
    props.buttonShape !== 'card' &&
    css`
      min-height: ${props.linkHeight}px;

      @media (max-width: 797px) {
        min-height: ${props.linkHeight}px;
      }
    `}

  ${(props) =>
    props.isButtonRadius &&
    css`
      border-radius: 36px;
    `}



  ${(props) =>
    props.isBorder &&
    css`
      outline: 2px solid ${props.textColor};
    `}

  ${(props) =>
    props.isTopBottomPadding &&
    css`
      padding-top: 17px;
      padding-bottom: 17px;
    `}


  ${(props) =>
    props.digital &&
    css`
      padding: 15px;
      min-height: 98px;
    `}


  ${(props) =>
    props.digital &&
    props.buttonShape === 'card' &&
    css`
      padding-top: 75px;
    `}

  ${(props) =>
    props.previewItem &&
    css`
      margin-bottom: 12px;
    `}


  ${(props) =>
    props.digital &&
    props.buttonShape === 'card' &&
    css`
      padding-top: 285px;
    `}

  ${(props) =>
    props.digital &&
    (props.background === '#fff' || props.background === '#ffffff' || props.background === 'white') &&
    css`
      outline: 1px solid var(--border-color);
    `}

    ${(props) =>
    props.buttonShape === 'squareEvents' &&
    props.image &&
    css`
      background: url(${props.image}) no-repeat center / cover;
      padding-top: 30%;
      border-radius: 16px;
      margin: 0 auto;
      justify-content: end;
    `}

    ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
    ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding} !important;
    `}

    ${(props) =>
    props.isNoOutline &&
    css`
      outline: none;
    `}

    ${(props) =>
    props.isEvents &&
    props.buttonShape === 'ticket' &&
    css`
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: start;
      gap: 64px;
      min-height: 128px;
    `}

  ${(props) =>
    props.buttonShape === linkDesignTypes.round &&
    css`
      padding-left: 24px;
      padding-right: 24px;
    `}

    ${(props) =>
    props.shape === 'round' &&
    css`
      border-radius: 36px !important;

      &:hover {
        border-radius: 36px !important;
      }
    `}

  ${(props) =>
    props.border === 'solid' &&
    css`
      border: 2px solid ${props.borderColor} !important;

      &:hover {
        border: 2px solid ${props.borderColor} !important;
      }
    `}
  ${(props) =>
    props.border === 'none' &&
    css`
      border: none !important;
      outline: none !important;
    `}

    ${(props) =>
    props.shadow === 'hard' &&
    css`
      box-shadow: ${props.shadowColor} 8px 8px 0 0;
    `}
    ${(props) =>
    props.shadow === 'soft' &&
    css`
      ${shadowSoft};
    `}

    ${(props) =>
    props.shadow === 'hard' &&
    props.border === 'double' &&
    css`
      box-shadow:
        ${props.shadowColor} 8px 8px 0 0,
        ${props.borderColor} 8px 8px 0 2px;
      border: 2px solid ${props.borderColor} !important;
    `}

  ${({ shape }) =>
    shape === 'square' &&
    css`
      border-radius: 8px !important;
      &:hover {
        border-radius: 8px !important;
      }
    `}

    ${({ shape }) =>
    shape === 'round' &&
    css`
      border-radius: 36px !important;
      &:hover {
        border-radius: 36px !important;
      }
    `}
`;

export const ModalImageTitle = styled(Box)`
  //max-height: 23px;
  overflow: hidden;

  font-size: 18px;
  font-weight: bold;
  color: #fff;

  ${(props) =>
    props.isMarginBottom &&
    css`
      margin-bottom: 5px;
    `}

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}

  ${(props) =>
    props.textAlign &&
    css`
      text-align: ${props.textAlign};
    `}

  ${(props) =>
    props.digital &&
    css`
      padding-left: 80px;
    `}

  ${(props) =>
    props.digital &&
    (props.buttonShape === 'card' || props.buttonShape === 'cover') &&
    css`
      padding-left: 15px;
    `}

  ${(props) =>
    props.digital &&
    props.buttonShape === linkDesignTypes.full &&
    css`
      padding-left: 36%;

      @media (max-width: 568px) {
        padding-left: 36%;
      }
    `}

  ${(props) =>
    props.digital &&
    props.buttonShape === linkDesignTypes.full &&
    css`
      padding-left: 36%;
    `}

  ${(props) =>
    props.buttonShape === 'square' &&
    css`
      margin-bottom: 0;
    `}

  ${(props) =>
    props.digital &&
    props.buttonShape === linkDesignTypes.button &&
    css`
      padding-left: 0;
    `}

  ${(props) =>
    props.hide &&
    css`
      display: none;
    `}

    ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding} !important;
    `}
`;

export const ModalImageLinkButtonBox = styled(Box)`
  position: absolute;
  top: 50%;
  left: 10px;
  width: 49px;
  height: 49px;
  margin-top: -24px;
  border-radius: 4px;
  cursor: pointer;
  cursor: pointer;

  @media (max-width: 568px) {
    width: 30px;
    height: 30px;
  }

  ${(props) =>
    props.border &&
    css`
      border: 1px solid var(--border-color);
    `}
  ${(props) =>
    props.buttonLinkContainer &&
    css`
      flex: none;
      position: static;
      margin: 0 20px 0 0;

      @media (max-width: 568px) {
        margin: 0 8px 0 0;
      }
    `}

  ${(props) =>
    props.buttonShape === 'full' &&
    css`
      top: 0;
      left: 0;
      width: 33%;
      height: 100%;
      margin-top: 0;
    `}

  ${(props) =>
    props.buttonShape === 'card' &&
    css`
      top: 0;
      left: 0;
      margin: 0;
      width: 100%;
      height: ${props.height}px;
    `}

  ${(props) =>
    props.digital &&
    css`
      top: 12px;
      margin-top: 0;
    `}

  ${(props) =>
    props.digital &&
    (props.buttonShape === 'round' || props.buttonShape === 'square') &&
    css`
      width: 75px;
      height: 75px;
    `}

  ${(props) =>
    props.digital &&
    props.buttonShape === linkDesignTypes.full &&
    css`
      top: 0;

      @media (max-width: 568px) {
        width: 33%;
        height: 100%;
      }
    `}

  ${(props) =>
    props.digital &&
    props.buttonShape === linkDesignTypes.full &&
    props.isInsideDashboard &&
    css`
      width: 33%;
    `}

  ${(props) =>
    props.digital &&
    props.buttonShape === linkDesignTypes.card &&
    css`
      top: 0;

      @media (max-width: 568px) {
        width: 100%;
        height: 100%;
      }
    `}

  ${(props) =>
    props.digital &&
    props.buttonShape === 'full' &&
    css`
      @media (max-width: 568px) {
        height: 100%;
      }
    `}


  ${(props) =>
    props.coupon &&
    css`
      flex: none;
      position: static;
      margin: 0;
      width: 100px;
      height: 100px;
      overflow: hidden;
    `}

  ${(props) =>
    props.isMarginBottom &&
    css`
      margin-bottom: 10px;
    `}
`;

export const ModalImageLinkButtonIcon = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 4px;


  @media (max-width: 568px) {
    width: 30px;
    height: 30px;
  }

  ${(props) =>
    props.border &&
    css`
      border: 1px solid var(--border-color);
    `}
  ${(props) =>
    props.buttonShape === 'round' &&
    css`
      border-radius: 50%;
    `}

  ${(props) =>
    props.buttonShape === 'full' &&
    css`
      border-radius: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;

      @media (max-width: 568px) {
        width: 90px;
        height: 100%;
      }
    `}

  ${(props) =>
    props.digital &&
    (props.buttonShape === 'round' || props.buttonShape === 'square') &&
    css`
      width: 75px;
      height: 75px;
      object-fit: cover;

      @media (max-width: 568px) {
        width: 75px;
        height: 75px;
      }
    `}


}




  ${(props) =>
    props.buttonShape === 'full' &&
    props.digital &&
    props.isButton &&
    css`
      width: 100%;
      height: 100%;

      @media (max-width: 568px) {
        width: 100%;
        height: 100%;
      }
    `}


  ${(props) =>
    props.buttonShape === 'card' &&
    css`
      width: 100%;
      height: ${props.height}px;
      object-fit: cover;
      border-radius: 0;
    `}


  ${(props) =>
    props.digital &&
    props.buttonShape === 'card' &&
    css`
      width: 100%;
      height: 265px;
      object-fit: cover;
      border-radius: 0;

      @media (max-width: 568px) {
        width: 100%;
        height: 265px;
      }
    `}

  ${(props) =>
    props.coupon &&
    css`
      width: 100px;
      height: 100px;
      border-radius: 0;
    `}
`;

export const PreWrapText = styled.div`
  white-space: pre-wrap;
  max-height: 36px;
  overflow: hidden;
  text-overflow: ellipsis;

  ${(props) =>
    props.maxHeight &&
    css`
      max-height: ${props.maxHeight};
    `}
  ${(props) =>
    props.minHeight &&
    css`
      min-height: ${props.minHeight};
    `}
`;

export const ModalImageText = styled(Box)`
  max-height: 55px;
  overflow: hidden;
  color: #fff;

  ${(props) =>
    props.color &&
    css`
      color: ${props.color};
    `}

  ${(props) =>
    props.insideLinks &&
    css`
      max-height: initial;
    `}

  ${(props) =>
    props.textAlign &&
    css`
      text-align: ${props.textAlign};
    `}

  ${(props) =>
    props.digital &&
    css`
      padding-left: 80px;
      font-size: 14px;
    `}

  ${(props) =>
    props.digital &&
    (props.buttonShape === 'card' || props.buttonShape === 'cover') &&
    css`
      padding-left: 15px;
    `}

  ${(props) =>
    props.digital &&
    props.buttonShape === linkDesignTypes.full &&
    css`
      padding-left: 36%;

      @media (max-width: 568px) {
        padding-left: 36%;
      }
    `}

  ${(props) =>
    props.digital &&
    props.buttonShape === linkDesignTypes.full &&
    props.isInsideDashboard &&
    css`
      padding-left: 36%;
    `}

  ${(props) =>
    props.digital &&
    props.buttonShape === linkDesignTypes.button &&
    css`
      padding-left: 0;
    `}

  ${(props) =>
    props.background &&
    css`
      background: ${props.background};
      border-radius: 16px;
      width: fit-content;
      padding: 4px 16px;
      margin-top: 4px;
      margin-left: 16px;
    `}

    ${(props) =>
    props.lessPadding &&
    css`
      padding-lef: 36%;
    `}
    ${(props) =>
    props.fontSize &&
    css`
      font-size: ${props.fontSize};
    `}
    ${(props) =>
    props.flex &&
    css`
      display: flex;
      align-items: center;
      gap: 8px;
      margin-left: 0;
    `}

  ${(props) =>
    props.hide &&
    css`
      display: none;
    `}

    ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding} !important;
    `}

    ${(props) =>
    props.links &&
    props.buttonShape === linkDesignTypes.round &&
    css`
      padding-left: 45px;
      padding-right: 25px;
    `}
`;

export const ActionModalContent = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 450px;

  @media (max-width: 992px) {
    margin-left: 0;
    width: 100%;
  }

  ${(props) =>
    props.isLesson &&
    css`
      width: 100%;
    `}

  ${(props) =>
    props.addUrlType &&
    css`
      width: 100%;
      min-height: 235px;
    `}

  ${(props) =>
    props.minHeight &&
    css`
      min-height: ${props.minHeight};
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.modalLink &&
    css`
      width: 100%;
      max-width: 675px;
      margin-right: 50px;
    `}
}
`;

export const ModalLink = styled(Box)`
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
`;

export const ModalTitleBox = styled(Box)`
  display: flex;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const ModalTitleItem = styled(Box)`
  ${(props) =>
    props.dropwdown &&
    css`
      width: 100px;
      flex: none;
    `}

  ${(props) =>
    props.title &&
    css`
      width: 100%;
      margin-left: 18px;
    `}
`;

export const ModalPropertiesList = styled(Box)`
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  ${(props) =>
    props.viewLabel &&
    css`
      overflow-y: initial;
      gap: 16px;
    `}
`;

export const ModalPropertiesItem = styled(Box)``;

export const ModalPropertiesInputBox = styled(Box)`
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow-y: auto;

  ${(props) =>
    props.viewLabel &&
    css`
      margin: 0;
      overflow-y: initial;

      & > .ButtonLinkMenuItem {
        flex-shrink: 0;
      }
    `}
`;

export const ModalContentAddInstagram = styled(Box)`
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 30px;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    padding: 0;
    margin-top: 20px;
  }
`;

export const ModalAddTikTokButtonBox = styled(Box)`
  display: flex;
  justify-content: flex-end;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const ModalCategoriesList = styled(Box)`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

export const ModalCategoriesItem = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const ModalCategoriesAction = styled(Box)`
  cursor: pointer;
  color: #0155fa;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  margin-top: 12px;
  padding: 15px;
  line-height: 22px;
  border: 2px dashed rgba(1, 85, 250, 0.3);
  border-radius: 12px;
  background: transparent;
  transition:
    background 120ms ease,
    border-color 120ms ease;

  &:hover {
    background: transparent;
    border-color: #0155fa;
  }

  ${(props) =>
    props.disabled &&
    css`
      cursor: default;
      color: #9393a0;
      border-color: #e0e2e9;
      &:hover {
        background: transparent;
        border-color: #e0e2e9;
      }
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const ModalAnalyticsMenuBox = styled(Box)`
  margin-top: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;

  //outline: 1px solid deeppink;
`;

export const ModalAnalyticsMenuIcon = styled.img`
  width: 30px;
  height: 20px;
  margin-top: -2px;
  padding: 0 10px;

  [data-theme='dark'] & {
    filter: invert(1);
  }

  ${(props) =>
    props.isShowingItems &&
    css`
      transform: rotate(180deg);
    `}

  ${(props) =>
    props.isBlock &&
    css`
      position: absolute;
      top: 50%;
      right: 5px;
      margin-top: -3px;
    `}

  ${(props) =>
    props.chooseDomain &&
    css`
      position: absolute;
      top: 50%;
      right: 2px;
    `}
`;
